import { useState } from "react";
import { Link } from "react-router-dom";
import { PublicValidatedUser } from "../../../shared/types";
import { Page } from "../../components/page/page";
import { Validate } from "./views/validate";
import { LoginForm } from "./views/loginForm";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { useApp } from "../../hooks/use-app/useApp";
import { useStore } from "../../hooks/use-store/useStore";

export const Login: React.FC = () => {
  const { localize } = useLocalization();
  const query = useStore().query;
  const app = useApp();
  const [validatedUser, setValidatedUser] =
    useState<PublicValidatedUser | null>(
      query.email
        ? {
            email: query.email,
            name: query.name,
            providers: query.providers || [],
          }
        : null,
    );

  function renderView() {
    if (!validatedUser) {
      return (
        <>
          <Validate onValidate={setValidatedUser} />{" "}
          {!app.inviteOnly && (
            <p id="register">
              {localize("login:newUser")}{" "}
              <Link to="../registrer" relative="path">
                {localize("login:registerHere")}
              </Link>
            </p>
          )}
        </>
      );
    }

    return (
      <>
        <LoginForm
          user={validatedUser}
          onLogin={(redirect) => (window.location.href = redirect)}
        />
        <button onClick={() => setValidatedUser(null)}>Tilbake</button>
      </>
    );
  }

  return (
    <Page title={localize("login:title", app.label || app.name)}>
      {renderView()}
    </Page>
  );
};
